import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Action } from 'src/common/components/ConfigurableTable/models/configurableTable';
import { ESimEnableProfileDialog } from '../actions/ESimEnableProfileDialog';
import { ESimProfile } from '../models/eSimProfiles';
import { ESimDeleteProfileDialog } from '../actions/ESimDeleteProfileDialog';

export const useESimProfilesTableActions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    const menuActions: Action<ESimProfile>[] = [
      {
        id: 'enableProfile',
        label: t('products.eSim.inventory.actions.enable.title'),
        type: 'dialog',
        Component: ESimEnableProfileDialog,
        enabled: (data: ESimProfile) => !data.enabled,
      },
      {
        type: 'separtor',
      },
      {
        id: 'deleteProfile',
        label: t('products.eSim.inventory.actions.deleteESimProfile.deleteProfile'),
        type: 'dialog',
        Component: ESimDeleteProfileDialog,
        enabled: (data: ESimProfile) => !data.enabled,
        slotProps: {
          menuItemText: {
            slotProps: {
              primary: {
                color: 'red.600',
              },
            },
          },
        },
      },
    ];

    return menuActions;
  }, []);
};
